import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';

const FadeInAndOutWrapper = styled(CSSTransition)`
  &.enter {
    opacity: 0;
    transform: translateX(-50px);
    max-height: 0px;
  }
  &.enter-active {
    max-height: 300px;
    opacity: 1;
    transform: translateX(0px);
    transition: transform 0.3s ease-in 0.2s, opacity 0.3s ease-in 0.2s, max-height 0.2s ease-in;
  }
  &.exit {
    max-height: 300px;
    opacity: 1;
    transform: translateX(0px);
  }
  &.exit-active {
    max-height: 0px;
    opacity: 0;
    transform: translateX(-50px);
    transition: opacity 0.3s ease-in, transform 0.3s ease-in, max-height 0.2s ease-in 0.3s;
  }
`;

type Props = {
  readonly children: JSX.Element | JSX.Element[];
  readonly timeout: number;
  readonly in?: boolean;
  readonly unmountOnExit?: boolean;
};

const FadeInAndOut = ({ children, ...rest }: Props): JSX.Element => {
  return (
    <FadeInAndOutWrapper {...rest}>
      <div>{children}</div>
    </FadeInAndOutWrapper>
  );
};

export default FadeInAndOut;
